export default __webpack_public_path__ + "static/img_3-d6b60c1f9101a5f751ad67f3bb64a209.png";